import { FC, useEffect, useState } from 'react';

import { ActionItem } from '../model';
import { STICKY_PAGE_ACTIONS_TEST_ID } from '../test-ids';
import {
    ActionButtonIcon,
    ActionButtonTitle,
    ActionContainer,
    BadgeCount,
    StyledActionButton,
} from './StickyPageActions.styles';

type Props = {
    action: ActionItem;
};

export const ActionButton: FC<Props> = ({ action }) => {
    const [isHidden, setIsHidden] = useState(!action.isVisible);

    useEffect(() => {
        const timerHandle = window.setTimeout(() => setIsHidden(!action.isVisible), 200);

        return () => {
            window.clearTimeout(timerHandle);
        };
    }, [action.isVisible]);

    return (
        <ActionContainer
            $isTransparent={!action.isVisible}
            $isHidden={isHidden}
            data-test={`${STICKY_PAGE_ACTIONS_TEST_ID.ACTION}-${action.id}`}
        >
            <StyledActionButton onClick={action.onClick} aria-label={action.title}>
                <ActionButtonTitle>{action.title}</ActionButtonTitle>
                <ActionButtonIcon>
                    <i className={`icon icon-${action.icon}`} aria-hidden={true} />
                </ActionButtonIcon>
                {typeof action.badgeCount !== 'undefined' && (
                    <BadgeCount data-test={`${STICKY_PAGE_ACTIONS_TEST_ID.BADGE_COUNT}-${action.id}`}>
                        {action.badgeCount}
                    </BadgeCount>
                )}
            </StyledActionButton>
        </ActionContainer>
    );
};
